import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AdSense from 'react-adsense';
import { useNavigate, Link, useParams } from "react-router-dom";
import { alert_error, alert_success } from './../AppContext';
import { Cookies } from './../index.js';
import { ClipLoader } from "react-spinners";
const InviteFriends = ({ setUserOption }) => {
    const [nutxuly, setnutxuly] = useState(0);
    const [nutorder, setnutorder] = useState('✔️ Click to Confirm');
    const { slug_2 } = useParams();
    const [money, setmoney] = useState('');
    const datahome = {
        links: [
            { to: "/shop/wallet/pay_crypto?showadview=true&servicecode=crypto", text: "Chuyển số dư qua ngân hàng", userOption: "pay_edit" },
            { to: "/shop/doithe/pay_edit?showadview=true", text: "Cấu hình ngân hàng", userOption: "pay_edit" }
        ]
    };
    const laythongtin = (apikey, service) => {
        const domain = window.location.hostname;
        axios
            .get('https://hust.media/jop/pay/checktk.php', {
                params: {
                    apikey: apikey,
                    domain: domain,
                    chedo: 'pay_bank',
                    doithe: 'doithe'
                }
            })
            .then(response =>
                testFunction4(response, service)
            )
            .catch(error => console.log(123 + error));
    };
    const testFunction4 = (response, service) => {
        console.log(response);
        const info = response.data;
        const status = info.status;
        if (info.money_crypto) {
            setmoney(info.money_crypto);
        }
        if (status == 0) {
            alert_error(info.message);
        }
        if (info.redirect != null && info.redirect != '') {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                switch_router(info.redirect);
                setTimeout(function () {
                    // Chuyển hướng sang trang web khác
                    const urlok = window.location.href; // Lấy URL hiện tại
                    const uriok = urlok.split('/').pop().split('?')[0].split('#')[0]; // Lấy phần URI cuối cùng, bỏ qua query string và fragment
                    if (uriok) {
                        setUserOption(uriok);
                    }
                }, 200);
            }, 200);
        }
    };
    const laydulieu = () => {
        const apiKey = Cookies.get('apikey');
        if (apiKey !== null) {
            // Có API key, thực hiện các hành động cần thiết
            laythongtin(apiKey, 'getmoney');
        } else {
            // Không có API key, thực hiện các hành động khác (ví dụ: yêu cầu người dùng nhập API key)
            console.log('Không có API key.');
        }
    };
    useEffect(() => {
        // Kiểm tra xem có giá trị "apikey" trong AsyncStorage không
        laydulieu();
    }, []);
    const navigate = useNavigate();
    function switch_router(link) {
        navigate(link);
    };
    function chuyen_router(link) {
        setUserOption(link.userOption);
        navigate(link.to);
    };
    return (
        <div className="mt-2 mx-2">
            {!money ? (<>
                <div style={{ textAlign: "center" }} className="mt-4 justify-center items-center">
                    <ClipLoader size={90} color="#8a2be2" />
                </div>
            </>) : (<>
                <div className="max-w-xl mt-2 mx-2 mx-auto">
                    <div className="bg-white p-2 rounded-md shadow-md ">
                        <div className="bg-gray-100 rounded-md shadow-md border-1 border-purple-300">
                            <div className="text-base mt-2 text-center font-semibold">Hạn mức điểm tiền số :
                                <div className="text-xs"> Tăng khi đổi thẻ</div>
                            </div>
                            <div className="mb-2 text-center text-lg text-purple-700">{money} Coins</div>
                        </div>
                    </div>
                    <form className="mt-2 mb-1 add-form">
                        <div className="form-control">
                            <div className="mx-2">
                                <label className="mt-1 text-base">Để nhận vnđ coin bạn cần rút số
                                    dư hust coin .
                                </label>
                                <div className="max-w-5xl mx-auto">
                                    <div className="bg-white p-3 rounded-md shadow-md md:col-span-2">
                                        <div className="fixrow row text-center">
                                            {datahome.links.map((link, index) => (
                                                <div
                                                    style={{ textDecoration: 'none' }}
                                                    onClick={() => chuyen_router(link)}
                                                    className="flex break-inside bg-white text-black border-2 border-black rounded-3xl px-6 py-3 w-auto dark:bg-slate-800 dark:text-white"
                                                    key={index}
                                                >
                                                    <div className="m-auto">
                                                        <div className="flex items-center justify-start flex-1 space-x-4">
                                                            <span className="font-medium px-2 text-lg">{link.text}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div className="cards">
                        <AdSense.Google
                            client="ca-pub-4574266110812955"
                            slot="3259681051"
                            style={{ display: 'block' }}
                            format="auto"
                            responsive="true"
                        /></div>
                </div>
            </>)}
        </div>
    );
};

export default InviteFriends;
